export const GENDERS = [
  { value: 'male', label: 'users.GENDERS.male' },
  { value: 'female', label: 'users.GENDERS.female' },
  { value: 'other', label: 'users.GENDERS.other' }
]

export const CIVIL_STATUS = [
  { value: 'single', label: 'users.CIVIL_STATUS.single' },
  { value: 'married', label: 'users.CIVIL_STATUS.married' },
  { value: 'divorced', label: 'users.CIVIL_STATUS.divorced' },
  { value: 'separated', label: 'users.CIVIL_STATUS.separated' },
  { value: 'widower', label: 'users.CIVIL_STATUS.widower' }
]

export const IDENTIFICATION_TYPES = [
  { value: 'dni', label: 'users.IDENTIFICATION_TYPES.dni' },
  { value: 'nie', label: 'users.IDENTIFICATION_TYPES.nie' },
  { value: 'passport', label: 'users.IDENTIFICATION_TYPES.passport' },
  { value: 'other', label: 'users.IDENTIFICATION_TYPES.other' }
]

export const STUDY_LEVELS = [
  { value: 'primary', label: 'users.STUDY_LEVELS.primary' },
  { value: 'secondary', label: 'users.STUDY_LEVELS.secondary' },
  { value: 'university', label: 'users.STUDY_LEVELS.university' },
  { value: 'other', label: 'users.STUDY_LEVELS.other' }
]

export const DEPARTMENTS = [
  { value: 'it', label: 'users.DEPARTMENTS.it' },
  { value: 'rrhh', label: 'users.DEPARTMENTS.rrhh' },
  { value: 'logistica', label: 'users.DEPARTMENTS.logistica' },
  { value: 'other', label: 'users.DEPARTMENTS.other' }
]

export const WORKCENTERS = [
  { value: 'madrid', label: 'Madrid' },
  { value: 'sevilla', label: 'Sevilla' }
]

export const LANGUAGES = [
  { value: 'es', label: 'users.LANGUAGES.es' },
  { value: 'en', label: 'users.LANGUAGES.en' }
]